<!-- @format -->

<ng-container *ngFor="let scheme of schemas; trackBy: trackByFn">
	<div class="product-recommendations">
		<div class="header3 product-recommendations-header">
			<span *ngIf="scheme.explanation !== undefined || scheme.explanation !== ''">
				{{ scheme.explanation }}
			</span>
			<span *ngIf="scheme.explanation === undefined || scheme.explanation === ''">
				{{ scheme.displayName }}
			</span>
			<a
				href="/s/recommended-for-you"
				class="view-all"
				*ngIf="showViewMoreLink"
				>View All</a
			>
		</div>
		<div class="product-recommendation-container">
			<div
				class="product-recommendation-cards d-flex flex-row"
				[ngClass]="{ 'justify-center': scheme.items.length <= 6 }">
				<div
					class="product-recommendation-card-container"
					*ngFor="let item of scheme.items; let index = index; trackBy: trackByFn">
					<div
						class="product-recommendation h-100"
						*ngIf="index < productDisplayLimit">
						<a
							class="d-flex flex-column align-items-stretch h-100 url"
							[href]="item.URL">
							<img
								class="align-self-center cross-sell-img"
								[src]="item.ImageURL"
								alt="Product"
								loading="lazy" />
							<div
								class="align-self-start ratings-and-reviews-stars"
								[ngClass]="{
									'ratings-and-reviews-stars-empty': item.CustomerRating === '0'
								}"
								*ngIf="item.CustomerRating > '0'">
								<span
									class="bv_rating"
									*ngIf="item.ratings?.length === 0">
									<homefield-icon
										class="star-icons star-icons--border"
										*ngFor="let star of item.ratings; trackBy: trackByFn"
										[name]="star"></homefield-icon>
								</span>
								<span
									class="bv_rating"
									*ngIf="item.ratings?.length > 0">
									<homefield-icon
										class="star-icons"
										*ngFor="let star of item.ratings; trackBy: trackByFn"
										[name]="star"></homefield-icon>
								</span>
								<span class="recommendation-review-count">
									{{ item.ReviewCount }}
								</span>
							</div>
							<div class="align-self-start cross-sell-desc">
								<span [innerHTML]="item.Name | dcsgSanitizeHtml"></span>
							</div>
							<div class="align-self-start list-view-item-price">
								<span *ngIf="item.minofferprice < item.maxmapprice"
									>See Price In Cart</span
								>
								<div *ngIf="item.minofferprice >= item.maxmapprice">
									<span>{{ item.minofferprice | currency }}</span
									><span *ngIf="item.minofferprice !== item.maxofferprice"
										>&nbsp;to&nbsp;{{ item.maxofferprice | currency }}</span
									>
								</div>
							</div>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>
